<template>
    <div class="marriage-page">
        <!-- 1. 标题部分 -->
        <div class="report-title-bar marriage-title-bar dsp-flex">
            <div class="report-title-side">
                <span class="report-title-back" @click="clickBack"><i class="iconfont icon-xiangzuo"></i></span>
            </div>
            <div class="report-title-mid"><span>缘分测测</span></div>
            <div class="report-title-side">
                <div class="marriage-title-icon" @click="clickRecord"></div>
            </div>
        </div>
        <div class="marriage-content-box">
            <!-- 2. 介绍内容部分 -->
            <div class="marriage-info-content"></div>
            <!-- 3. 表单部分 -->
            <div class="marriage-form-content-box pr" :class="marriageType == 1 ? 'marriage-form-type1' : 'marriage-form-type2'">
                <div class="marriage-little-bg little-bg1"></div>
                <div class="marriage-form-tab-box">
                    <div class="marriage-form-tab" @click="toggleTab(2)"></div>
                    <div class="marriage-form-tab" @click="toggleTab(1)"></div>
                </div>
                <!-- 婚姻合婚 -->
                <div v-if="marriageType == 2" class="marriage-form-content-content">
                    <!-- 男方信息 -->
                    <div class="marriage-form-content-item pr dsp-flex">
                        <div class="marriage-form-content-item-title">
                            <div class="title-icon icon-male"></div>
                            <p>男方信息</p>
                        </div>
                        <div class="marriage-form-content-item-input-box">
                            <div class="marriage-form-content-item-input-item clearfix">
                                <span>男方昵称：</span><input class="marriage-form-input" type="text" v-model="marriageFormData.firstName" placeholder="请输入" />
                            </div>
                            <div class="marriage-form-content-item-input-item clearfix" @click.stop="clickBirthDay('first')">
                                <span>出生时间：</span>
                                <div v-if="marriageFormData.firstBirthtime.length > 0" class="form-content-text">
                                    <p class="text1">{{ marriageFormData.firstBirthtime[0] }}</p>
                                    <p class="text2">{{ marriageFormData.firstBirthtime[1] }}</p>
                                </div>
                                <span v-else class="marriage-form-span-text">请输入（以当地时间为准）</span>
                            </div>
                            <div class="marriage-form-content-item-input-item clearfix" @click.stop="clickLocation('first')">
                                <span>出生地点：</span>
                                <div v-if="marriageFormData.firstLocationStr.length > 0" class="form-content-text">
                                    <p class="text1">{{ marriageFormData.firstLocationStr[0] }}</p>
                                    <p class="text2">{{ marriageFormData.firstLocationStr[1] }}</p>
                                </div>
                                <span v-else class="marriage-form-span-text">可选择，将纠正地区时差更准确</span>
                            </div>
                        </div>
                        <!-- 选人 -->
                        <div class="marriage-form-select-button" @click="clickSelect('first')"></div>
                    </div>
                    <!-- 女方信息 -->
                    <div class="marriage-form-content-item pr dsp-flex">
                        <div class="marriage-form-content-item-title">
                            <div class="title-icon icon-female"></div>
                            <p>女方信息</p>
                        </div>
                        <div class="marriage-form-content-item-input-box">
                            <div class="marriage-form-content-item-input-item clearfix">
                                <span>女方昵称：</span><input class="marriage-form-input" type="text" v-model="marriageFormData.secondName" placeholder="请输入" />
                            </div>
                            <div class="marriage-form-content-item-input-item clearfix" @click.stop="clickBirthDay('second')">
                                <span>出生时间：</span>
                                <div v-if="marriageFormData.secondBirthtime.length > 0" class="form-content-text">
                                    <p class="text1">{{ marriageFormData.secondBirthtime[0] }}</p>
                                    <p class="text2">{{ marriageFormData.secondBirthtime[1] }}</p>
                                </div>
                                <span v-else class="marriage-form-span-text">请输入（以当地时间为准）</span>
                            </div>
                            <div class="marriage-form-content-item-input-item clearfix" @click.stop="clickLocation('second')">
                                <span>出生地点：</span>
                                <div v-if="marriageFormData.secondLocationStr.length > 0" class="form-content-text">
                                    <p class="text1">{{ marriageFormData.secondLocationStr[0] }}</p>
                                    <p class="text2">{{ marriageFormData.secondLocationStr[1] }}</p>
                                </div>
                                <span v-else class="marriage-form-span-text">可选择，将纠正地区时差更准确</span>
                            </div>
                        </div>
                        <!-- 选人 -->
                        <div class="marriage-form-select-button" @click="clickSelect('second')"></div>
                    </div>
                </div>
                <!-- 个人姻缘 -->
                <div v-else-if="marriageType == 1" class="marriage-form-content-content">
                    <div class="marriage-form-content-lovers pr">
                        <div class="marriage-form-content-item-input-box">
                            <div class="marriage-form-content-item-input-item clearfix">
                                <span>主人昵称：</span><input class="marriage-form-input" type="text" v-model="marriageFormData.loverName" placeholder="请输入" />
                            </div>
                            <div class="marriage-form-content-item-input-item dsp-flex">
                                <span>性<i class="label-two"></i>别：</span>
                                <div class="marriage-form-sex" @click="selectSex(0)">
                                    <i class="iconbg icon-sex" :class="{'icon-male2' : marriageFormData.loverGender == 0, 'icon-none' : marriageFormData.loverGender == 1}"></i>男
                                </div>
                                <div class="marriage-form-sex" @click="selectSex(1)">
                                    <i class="iconbg icon-sex" :class="{'icon-female2' : marriageFormData.loverGender == 1, 'icon-none' : marriageFormData.loverGender == 0}"></i>女
                                </div>
                            </div>
                            <div class="marriage-form-content-item-input-item clearfix" @click.stop="clickBirthDay('lover')">
                                <span>出生时间：</span>
                                <div v-if="marriageFormData.loverBirthtime.length > 0" class="form-content-text form-content-text2">
                                    <p class="text1">{{ marriageFormData.loverBirthtime[0] }}</p>
                                    <p class="text2">{{ marriageFormData.loverBirthtime[1] }}</p>
                                </div>
                                <span v-else class="marriage-form-span-text marriage-form-span-text2">请输入（国内外皆以当地时间为准）</span>
                            </div>
                            <div class="marriage-form-content-item-input-item clearfix" @click.stop="clickLocation('lover')">
                                <span>出生地点：</span>
                                <div v-if="marriageFormData.loverLocationStr.length > 0" class="form-content-text form-content-text2">
                                    <p class="text1">{{ marriageFormData.loverLocationStr[0] }}</p>
                                    <p class="text2">{{ marriageFormData.loverLocationStr[1] }}</p>
                                </div>
                                <span v-else class="marriage-form-span-text marriage-form-span-text2">可选择，选择后将纠正地区时差更准</span>
                            </div>
                        </div>
                        <!-- 选人 -->
                        <div class="marriage-form-select-button" @click="clickSelect('lover')"></div>
                    </div>
                </div>
                <!-- 提交按钮 -->
                <div class="marriage-submit-btn-box">
                    <button class="marriage-submit-btn" @click="clickStart">马上测测</button> 
                </div>
            </div>
        </div>
        <div class="marriage-bottom-bg"></div>

        <!-- 1. 时间输入组件 -->
        <van-popup class="marriage-layout-input-birthday-pp" v-bind:value="showBirthday" position="bottom" @click-overlay="clickShowBirthdayOverlay">
            <marriage-input-birthday-panel></marriage-input-birthday-panel>
        </van-popup>
        <!-- 2. 选择地址组件 -->
        <van-overlay v-show="showLocation" @click="clickShowAreaOverlay" />
        <vant-area v-show="showLocation" v-bind:parentNode="parentNode"></vant-area>

        <!-- 子页面 -->
        <router-view></router-view>
    </div>
</template>

<script>
import MarriageInputBirthdayPanel from '../components/marriage/MarriageInputBirthdayPanel.vue';
import VantArea from '../layouts/vant/VantArea.vue';
export default {
  components: { MarriageInputBirthdayPanel, VantArea },
    name: 'Marriage',
    data(){
        return {
            parentNode: {'name': 'Marriage'},
        }
    },
    computed: {
        marriageType() {
            return this.$store.state.marriage.marriageType;
        },
        showBirthday() {
            return this.$store.state.marriage.showBirthday;
        },
        showLocation() {
            return this.$store.state.marriage.showLocation;
        },
        marriageFormData() {
            return this.$store.state.marriage.marriageFormData;
        },
        marriageFormData() {
            return this.$store.state.marriage.marriageFormData;
        }
    },
    mounted: function() {
        setTimeout(() => {
            // 初始化record数据
            if(!this.$store.state.record.gotRecordData){
                this.$store.dispatch('record/initRecordList');
            }
            window.scrollTo(0, 0);
        }, 20);
    },
    methods: {
        clickBack() {
            this.$router.replace({ path: '/collate' });
        },
        clickRecord() {
            this.$router.replace({ path: '/marriagerecord' });
            // for test
            // this.$router.replace({ path: '/marriageverify' });
        },
        toggleTab(type) {
            this.$store.state.marriage.marriageType = type;
        },
        selectSex(sex) {
            console.log('selectSex', sex);
            this.$store.state.marriage.marriageFormData.loverGender = sex;
        },
        clickBirthDay(type) {
            console.log('clickBirthDay', type);
            this.$store.state.marriage.showBirthday = true;
            this.$store.state.marriage.showBirthdayType = type;
            this.$store.dispatch('resetTimeInputData');

            switch(type) {
                case 'first':
                    // 男方
                    if(this.marriageFormData.firstBirthday) {
                        this.$store.dispatch('initTimeInputData', {time: this.marriageFormData.firstBirthday, from: 'marriage'});
                    }
                    break;
                case 'second':
                    // 女方
                    if(this.marriageFormData.secondBirthday) {
                        this.$store.dispatch('initTimeInputData', {time: this.marriageFormData.secondBirthday, from: 'marriage'});
                    }
                    break;
                case 'lover':
                    // 个人姻缘
                    if(this.marriageFormData.loverBirthday) {
                        this.$store.dispatch('initTimeInputData', {time: this.marriageFormData.loverBirthday, from: 'marriage'});
                    }
                    break;
                default:
                    break;
            }
        },
        clickShowBirthdayOverlay() {
            this.$store.state.marriage.showBirthday = false;
        },
        clickLocation(type) {
            this.$store.state.marriage.showLocation = true;
            this.$store.state.marriage.showLocationType = type;
        },
        clickShowAreaOverlay() {
            this.$store.state.marriage.showLocation = false;
        },
        clickSelect(type) {
            this.$store.state.marriage.chooseItemType = type;
            this.$store.state.chooserecord.chooseRecordGender = type == 'first' ? 1 : (type == 'second' ? 2 : 0);
            this.$store.state.chooserecord.chooseFromPage = 'marriage';
            this.$store.state.chooserecord.chooseRecordType = 'single';
            this.$router.replace({ path: '/marriage/chooserecord' });
        },
        clickStart() {
            console.log('马上测测', this.marriageType);            
            // 检测表单
            if(!this.checkMarriageForm()) {
                return;
            }
            this.$store.dispatch('marriage/addMarriageRecord', {
                sucCb: () => {
                    // 初次添加的合婚记录要进入到验证界面
                    this.$router.replace({ path: '/marriageverify' });
                }
            });
        },
        checkMarriageForm() {
            if(this.marriageType == 1) {
                // 个人姻缘
                if(this.marriageFormData.loverName == '') {
                    this.$toast('请输入昵称');
                    return false;
                }
                if(this.marriageFormData.loverBirthday == '') {
                    this.$toast('请输入出生时间');
                    return false;
                }
                return true;
            }else if(this.marriageType == 2) {
                // 婚姻合婚
                // 男方
                if(this.marriageFormData.firstName == '') {
                    this.$toast('请输入男方昵称');
                    return false;
                }
                if(this.marriageFormData.firstBirthday == '') {
                    this.$toast('请输入男方出生时间');
                    return false;
                }
                // 女方
                if(this.marriageFormData.secondName == '') {
                    this.$toast('请输入女方昵称');
                    return false;
                }
                if(this.marriageFormData.secondBirthday == '') {
                    this.$toast('请输入女方出生时间');
                    return false;
                }
                return true;
            }
        }
    }
}
</script>

<style scoped>
    
</style>
